import { FunctionComponent } from "react";
import NAV from "../components/NAV";

const Lesson16: FunctionComponent = () => {
  return (
    <div className="relative [background:linear-gradient(111.77deg,_rgba(0,_0,_0,_0),_#363636_78.54%),_#0d0d0d] w-full overflow-hidden flex flex-col items-center justify-center p-[2.69rem] box-border gap-[6.88rem] text-left text-[1.56rem] text-darkgray font-nunito">
      <NAV />
      <div className="self-stretch flex flex-row items-center justify-between">
        <a className="cursor-pointer text-darkgray no-underline" href={"/lesson15"}>
          <div className="rounded-32xl bg-gainsboro-200 box-border w-[9.81rem] h-[3.5rem] flex flex-col items-end justify-start py-[0.69rem] px-[3rem] border-[1px] border-solid border-gray-200">
            <b className="relative inline-block w-[3.75rem] h-[2.06rem] shrink-0">
              Back
            </b>
          </div>
        </a>
        <div className="flex-1 flex flex-col items-center justify-center text-center text-[2.81rem] text-white">
          <b className="self-stretch relative leading-[120%]">
            Common Mistakes
          </b>
        </div>
        <a className="cursor-pointer text-darkgray no-underline" href={"/lesson17"}>
          <div className="rounded-32xl bg-gainsboro-200 box-border w-[9.81rem] h-[3.5rem] flex flex-col items-end justify-start py-[0.69rem] px-[3rem] border-[1px] border-solid border-gray-200">
            <b className="relative inline-block w-[3.75rem] h-[2.06rem] shrink-0">
              Next
            </b>
          </div>
        </a>
      </div>
      <div className="flex flex-col items-center justify-center gap-[7.5rem] w-[92%] mr-[4%] max-w-[110rem] text-justify text-[1.88rem] text-white font-dm-sans">
        <div className="self-stretch flex flex-row items-center justify-center gap-[4.63rem]">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <p className="m-0">
              <b>
                <span>Common Crypto Mistakes</span>
              </b>
            </p>
            <p className="m-0 text-gainsboro-100">
              <span>
                <b>&nbsp;</b>
              </span>
            </p>
            <p className="m-0 text-[1.56rem]">
              <span>
                <span>
                  Investing in the right crypto at the right time takes luck but
                  more importantly precision and insight. Those who improve
                  their investment strategies every day will more than likely be
                  the ones to have successful portfolios.
                </span>
              </span>
            </p>
          </div>
          <img
            className="relative w-[42.81rem] h-[16.19rem] object-cover"
            alt=""
            src="/i69@2x.png"
          />
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0">
            <b>
              <span>The Most Common Mistakes</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <ul className="m-0 text-[1rem] pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>Listening To Only One Opinion</span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>Buying High and Selling Low</span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>Disregard For Security</span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>No Solid Trading Plan</span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>Investing Money That Cannot Be Afforded To Lose</span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>Doesn't Understand Basic Market Analysis</span>
              </span>
            </li>
            <li>
              <span>
                <span>
                  Diversificationwithin the space. Understanding market cap and
                  crypto correlations are important to diversifying your
                  portfolio.
                </span>
              </span>
            </li>
          </ul>
        </div>
        <div className="self-stretch flex flex-row items-center justify-center gap-[4.63rem] text-[1.56rem] text-gainsboro-100">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <p className="m-0 text-[1.88rem] text-white">
              <b>Buying High and Selling Low</b>
            </p>
            <p className="m-0">&nbsp;</p>
            <p className="m-0">
              Fear plays a massive role in crypto markets and if beginners are
              not careful they can lose a lot of money through their trading
              journey. Many newcomers see a huge trend or news headline and
              immediately buy into the hype.
            </p>
            <p className="m-0">&nbsp;</p>
            <p className="m-0">
              Crypto markets are extremely volatile and buying into hype trends
              can end disastrously. It's true that it is extremely hard to time
              the market. However, you should understand the basic patterns and
              trends to maximize your gains/losses from good entry and exit
              points.
            </p>
          </div>
          <img
            className="relative w-[42.81rem] h-[25.63rem] object-cover"
            alt=""
            src="/i70@2x.png"
          />
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem] text-[1.56rem]">
          <p className="m-0 text-[1.88rem]">
            <b>
              <span>
                <span>Notable Mistakes</span>
              </span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>
                <span>&nbsp;</span>
              </b>
            </span>
          </p>
          <ul className="m-0 text-[1rem] pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  <b>FOMO (Fear Of Missing Out)</b>
                </span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>
                  <span>
                    Timmy sees a crypto project skyrocketing in price and gets
                    very excited! He purchases some crypto at its high price
                    because he is worried he will miss out on another jump in
                    pricing. But he forgot a golden rule of trading; what goes
                    up must always come down.
                  </span>
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  <span>
                    Do NOT invest in a project while it's pumping without set
                    risk tolerance and proper trading strategies. There is a far
                    higher chance you lose money as earlier investors take their
                    profits.
                  </span>
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  <b>{`FUD (Fear, Uncertainity & Doubt`}</b>
                </span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>
                  <span>
                    Timmy's crypto purchase at that high market price has now
                    come down going deeper and deeper into the red. He decides
                    to sell because of FUD. The temptation to just get out is
                    extremely high and blinded his judgment. This was a strong
                    fundamental project which means there was a good chance it
                    could of recovered.
                  </span>
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li>
              <span>
                <span>
                  <span>
                    Crypto plays are naturally volatile. You will see a lot of
                    green but an equal amount of red if you are investing
                    properly. Losses are not solidified until you sell.
                  </span>
                </span>
              </span>
            </li>
          </ul>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0">
            <b>
              <span>Disregard For Security</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>
                Cryptocurrencies are unregulated and if something goes wrong,
                the chances of you recovering your money are little to none.
                Always take extra precautions to protect your assets. You are
                solely responsible for them.
              </span>
            </span>
          </p>
        </div>
        <div className="self-stretch relative text-[1.56rem] tracking-[0.02em] leading-[2rem] text-gainsboro-100">
          <p className="m-0">
            <b>Important:</b>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <ul className="m-0 text-inherit pl-[1.32rem]">
            <li className="mb-[false]">
              <span>
                Fake accounts and scammers are all over the entire
                cryptocurrency space.
              </span>
            </li>
            <li className="mb-[false]">
              <span>
                With decentralization comes a lot of malicious intent. Anything
                too good to be true isn't worth it. It might seem obvious but a
                lot of beginners fall for these tricks.
              </span>
            </li>
            <li className="mb-[false]">
              <span>
                Do NOT click any random links. They could be phishing to steal
                your information.
              </span>
            </li>
          </ul>
          <p className="m-0">&nbsp;</p>
          <ul className="m-0 text-inherit pl-[1.32rem]">
            <li className="mb-[false]">
              <span>
                Always protect your private key, password, and seed phrase.
              </span>
            </li>
            <li className="mb-[false]">
              <span>
                Do NOT save them on a computer, phone, send by email, store them
                in the cloud, etc.
              </span>
            </li>
            <li className="mb-[false]">
              <span>
                Store them in a cold (offline location) liking writing on a
                piece of paper.
              </span>
            </li>
            <li className="mb-[false]">
              <span>Ensure it's in a secure location with limited access.</span>
            </li>
            <li className="mb-[false]">
              <span>
                Consider a hardware wallet like Trezor or Ledger for larger
                portfolio holdings.
              </span>
            </li>
          </ul>
          <p className="m-0">&nbsp;</p>
          <ul className="m-0 text-inherit pl-[1.32rem]">
            <li className="mb-[false]">
              <span>
                Ensure you have Two-factor authentication (2FA) on all exchanges
                and wallets that support it.
              </span>
            </li>
            <li>
              <span>Gives an extra layer of protection to your assets.</span>
            </li>
          </ul>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem] text-[1.56rem]">
          <p className="m-0 text-[1.88rem]">
            <b>
              <span>No Solid Trading Plan</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  All crypto investors should have a solid trading plan. No
                  exceptions for any form of investing whether that be in low
                  cap altcoins or longing Bitcoin till 100K.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <b>
                  Here are some questions you should ask yourself to develop a
                  solid trading plan:
                </b>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <b>&nbsp;</b>
              </span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  <span>How much money do you want to invest?</span>
                </span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>
                  <span>How much risk are you willing to accept?</span>
                </span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>
                  <span>
                    When you are comfortable taking profits or cutting your
                    losses on any given play?
                  </span>
                </span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>
                  <span>Do you want to invest long/short term or both?</span>
                </span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>
                  <span>
                    How much time can you put into learning the basics of
                    trading?
                  </span>
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  These are all some fundamental questions that you should be
                  able to answer to help develop a sound trading plan! Be sure
                  to always layout various investment strategies and research
                  what works best for you given all the information you have.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  Do not make the mistake of entering into crypto trading
                  blindly!
                </span>
              </span>
            </span>
          </p>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0">
            <b>
              <span>Investing Money That Cannot Be Afforded To Lose</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>
                This may seem straightforward but there are people that get too
                excited and can spend more of their own money or overleverage
                themselves on trades.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>Always only invest what you can afford to lose!</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                Of course, no one plans to lose money but crypto is extremely
                volatile. All of those great gains come with great risk of loss
                as well.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                Any crypto investor or trader should be prepared to lose it all
                at any given moment. Keeping this in mind will allow for you to
                make cautious but smart decisions. The amount invested will
                differ for you all as that will depend on your own risk
                tolerances and circumstances.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                Understand all the risks involved in crypto and the worst-case
                scenario in every investment/trade.
              </span>
            </span>
          </p>
        </div>
        <div className="self-stretch flex flex-row items-center justify-center gap-[4.63rem]">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <p className="m-0">
              <b>
                <span>Not Understanding Basis Market Analysis</span>
              </b>
            </p>
            <p className="m-0 text-gainsboro-100">
              <span>
                <b>&nbsp;</b>
              </span>
            </p>
            <p className="m-0 text-[1.56rem]">
              <span>
                <span>
                  Many beginners make the mistake of thinking they have to know
                  in-depth analysis skills before making a trade. Some don't
                  even both to learn basic market analysis skills.
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>&nbsp;</span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  The ability to focus on important data in certain context can
                  be very beneficial in the crypto market.
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>&nbsp;</span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  Information like market capitalization, trading volume, coins'
                  supplies, etc are all important basic concepts you can use
                  when analyzing a cryptocurrency.
                </span>
              </span>
            </p>
          </div>
          <img
            className="relative w-[42.81rem] h-[30.38rem] object-cover"
            alt=""
            src="/i71@2x.png"
          />
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0">
            <b>
              <span>Common Mistakes</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <ul className="m-0 text-[1rem] pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  Putting all your eggs in one basket and not diversifying
                </span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>Overdiversifying causing loss of effective tracking</span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                Your portfolio should always be based on your investing goals
                and priorities. However, it should always be within reason.
                Having at least 5 coins is a great way to begin diversifying
                your portfolio. Do not go over 10 coins at one time because for
                most it becomes extremely inefficient to manage them all.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                For "safer" investments look into high market cap and
                established coins like Bitcoin, Ethereum, Solana.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                For "risker" investments into small-cap altcoins, it's smart to
                not overexpose yourself and spread the rest of your investments
                out.
              </span>
            </span>
          </p>
        </div>
      </div>
      <a className="w-full mb-[6rem] rounded-32xl bg-gainsboro-200 box-border flex flex-row items-center justify-between py-[0.75rem] px-[0rem] max-w-[25rem] text-center text-[2.81rem] border-[1px] border-solid border-gray-300"
        href="/lesson17">
        <div className="w-full">
          <b className="inline-block flex-1 w-full relative text-center max-md:pb-[0.8rem]">Next Chapter</b>
        </div>
      </a>
    </div>
  );
};

export default Lesson16;
